<template>
    <div>
        <painel-servicos v-if="!atendimentoEmAberto" />
        <view-arvore v-if="atendimentoEmAberto" :servicoAtendimento="servico" />

        <yes-cancel-dialog
            v-model="mostrarPromptTrocaIdentidade"
            @ok="confirmarTrocaIdentidade"
            @cancelar="cancelarMudancaIdentidade"
            >Você tem um atendimento em andamento. Trocar de identidade agora vai
            descartar o que já foi preenchido. Deseja continuar?</yes-cancel-dialog
        >
    </div>
</template>

<script>
import ViewArvore from "./arvore/ViewArvore.vue";
import PainelServicoes from "./PainelServicos.vue";
import YesCancelDialog from "../../componentes/YesCancelDialog.vue";
import { mapGetters, mapActions } from "vuex";
export default {
    components: {
        "painel-servicos": PainelServicoes,
        "view-arvore": ViewArvore,
        "yes-cancel-dialog": YesCancelDialog,
    },
    name: "atendimento",
    computed: {
        atendimentoEmAberto: function () {
            return this.$servicoAtendimento.atendimentoEmAberto();
        },
        servico: function () {
            return this.$servicoAtendimento;
        },
        ...mapGetters("contexto", ["contexto"]),
        ...mapGetters("autenticacao", ["trocaIdentidadePendente"]),
        mostrarPromptTrocaIdentidade: {
            get() {
                return this.trocaIdentidadePendente;
            },
            set(valor) {
                if (!valor) {
                    this.cancelarMudancaIdentidade();
                }
            },
        },
    },
    watch: {
        atendimentoEmAberto: {
            immediate: true,
            handler(emAberto) {
                if (emAberto) {
                    this.interceptarTrocaIdentidade(this._uid);
                } else {
                    this.cancelarInterceptacaoIdentidade(this._uid);
                }
            },
        },
    },
    beforeDestroy() {
        this.cancelarInterceptacaoIdentidade(this._uid);
    },
    methods: {
        ...mapActions("autenticacao", [
            "interceptarTrocaIdentidade",
            "cancelarInterceptacaoIdentidade",
            "confirmarMudancaIdentidade",
            "cancelarMudancaIdentidade",
        ]),
        confirmarTrocaIdentidade() {
            this.$servicoAtendimento.cancelar();
            this.confirmarMudancaIdentidade();
        },
    },
};
</script>
